import {
  QUOTATION_TRANSACTION_DOC_NUMBER_FILTER,
  QUOTATION_TRANSACTION_DOC_NUMBER_ORDER_FILTER,  
  QUOTATION_TRANSACTION_DOC_NUMBER_REF_FILTER,
  QUOTATION_TRANSACTION_SHOW_ONLY_MAX_REVISION,
} from "constants/ActionTypes";

const initialState = {
  docNumberFilter: "",
  docNumberOrderFilter: "",
  docNumberRefFilter: "",
  showOnlyMaxRevisionFilter: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case QUOTATION_TRANSACTION_DOC_NUMBER_FILTER:
      return {
        ...state,
        docNumberFilter: action.payload,
      };
    case QUOTATION_TRANSACTION_DOC_NUMBER_ORDER_FILTER:
      return {
        ...state,
        docNumberOrderFilter: action.payload,
      };
    case QUOTATION_TRANSACTION_DOC_NUMBER_REF_FILTER:
      return {
        ...state,
        docNumberRefFilter: action.payload,
      };
    case QUOTATION_TRANSACTION_SHOW_ONLY_MAX_REVISION:
      return {
        ...state,
        showOnlyMaxRevisionFilter: action.payload,
      };
    default:
      return state;
  }
};
